<!-- 活动 -->
<template>
  <div class="activities">
    <Top></Top>

    <div class="banxin">
      <div class="topCarousel">
        <el-carousel style="width:100%; margin:0 auto" :interval="4000" type="card">
          <el-carousel-item v-for="(item, index) in lbtList" :key="index">
            <img id="lbtImg" @click='goActiveEdit(item.idOrLink)' :src="item.imagLink + '!yunshangzg'">
            <h3 class="medium"></h3>
          </el-carousel-item>
        </el-carousel>
      </div>




      <el-container id="contain">
        <el-header>
          <h2>摄影大赛</h2>
          <span style="color: #a3973c">FAMOUS PHOTOGRAPHER AND EXCELLEND PHOTOGRAPHER</span>
        </el-header>
        <div id="app" v-cloak>
          <!-- <div class="bigBox">
          <span style="padding-right: 20px">查看更多</span>
                      </div> -->
          <div class="act-content">

            <template v-if="!activeList.length">
              <div class="art-item selx" v-for="item in 12" :key="item + Math.random()">

              </div>
            </template>

            <div v-else class="art-item" v-for="(item, index) in activeList" :key="index">
              <!-- 图片 -->
              <div class="item-img" @click='goActiveEdit(item.id)'>
                <img :src="item.cover.substr(0, 4) == 'http' ? item.cover : 'https://www.yunshangzg.com/' + item.cover">
              </div>
              <!-- 文字和按钮 -->
              <div class="item-foot">
                <div class="text">
                  <h5 style="font-weight: bold; color: #646464;">{{ item.mainTitle }}</h5>
                  <p>{{ item.endTime }} 结束 </p>

                </div>
                <el-button v-if="item.isUpload == 0" disabled style="background-color: #ccc;">活动已结束</el-button>
                <el-button v-else @click='goActiveEdit(item.id)'>立即参与</el-button>
              </div>
            </div>
          </div>
          <el-pagination background style="display: flex;justify-content: center;" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="queryObj.current" :page-size="queryObj.size"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>

      </el-container>
      <div class="activeFoot">
        <el-image :src="require('../imgs/publicActive.png')"></el-image>
      </div>
    </div>

    <!-- <el-container style="margin: 0 auto; width: 100%; text-align: center">
      <el-header>
        <h2>征稿</h2>
        <span style="color: #a3973c">FAMOUS PHOTOGRAPHER AND EXCELLEND PHOTOGRAPHER</span>
      </el-header>
      <div id="app" v-cloak>
        <div style="
            width: 100%;
            height: 30px;
            margin: 40px auto;
            padding: 36px 0px 0px 20px;
          ">
          <span style="float: right; padding-right: 20px">查看更多</span>
        </div>
        <div class="act-content">
          <div class="act-item" v-for="(o, i) in dataAr" :key="i">
            <a target="_blank" :href="'collect-admin-test.html?id=' + o.id">
              <div class="item-content" :style="
                'background:url(' +
                o.src +
                ')no-repeat;background-position:center;background-size:cover;position:relative;height:220px;overflow:hidden;'
              "></div>
            </a>
            <div class="act-title">
              <h3>{{ o.name }}</h3>
            </div>
            <el-row :gutter="10" type="flex" class="row-bg" style="top: 10px">
              <el-col :span="6"><span style="color: #dc3b3b">活动进行中</span></el-col>
              <el-col :span="12" :offset="11"><span class="grid-content bg-purple">{{ o.updateDate }} 结束</span>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    
                  </el-container> -->

    <!-- 回到顶部 -->
    <el-backtop :visibility-height="300">
      <div class="inn">
        <img src="@/imgs/backtop.png" alt="">
      </div>
    </el-backtop>
    <service />
    <shopFloat />
    <Foot></Foot>
  </div>
</template>
<script>
import Top from "../components/top";
import Foot from "../components/foot";
import { getActiveList } from '@/api/active.js'

export default {
  components: {
    Top, Foot
  },
  data() {
    return {
      queryObj: {
        current: 1,
        size: 10,
      },
      activeList: [], //活动列表
      total: 0,
      lbtList: [],//轮播图
    };
  },
  created() {
    console.log(this.timeToTimestamp());
    this.getLbt()
    this.getActiveList();
  },
  methods: {
    // 获取轮播图
    async getLbt() {
      const res = await this.$axios.get('/homeReception/findChart', { params: { commendType: 4, advertisementType: 1 } })
      this.lbtList = res.data
      // console.log( this.lbtList);
      this.getActiveList()
    },
    async getActiveList() {
      const res = await getActiveList(this.queryObj)
      // console.log(res);
      this.activeList = res.data.records
      this.total = res.data.total
      // console.log(this.activeList);
    },
    // 点击活动征稿跳转详情页
    goActiveEdit(activeId) {
      console.log(activeId);
      // 传活动id过去
      this.$router.push({
        path: '/activeDetail',
        query: {
          id: activeId
        }
      })
    },

    // 分页
    // 图片分页
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.queryObj.size = val
      this.getActiveList()

    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.queryObj.current = val
      this.getActiveList()

    },

    // 活动时间戳和当前时间戳对比方法
    timeToTimestamp(time) {
      let timestamp = Date.parse(new Date(time).toString());
      // console.log(time + "的时间戳为：" + timestamp);
      let dates = new Date();
      let times = dates.getTime();//时间戳
      // console.log(times);
      if (timestamp >= times) {
        return false
      } else {
        return true
      }
      //2021-11-18 22:14:24的时间戳为：1637244864707
    },

  },
};
</script>
<style lang='scss' scoped>
// // 移动端
// @media screen and (min-width: 375px) and (max-width: 1456px) {
//   /deep/ .el-carouse {
//     width: 100% !important;
//   }
// }

#contain {
  .el-header {
    margin: 60px auto 40px;
    width: 100%;
    text-align: center;

    h2 {
      font-size: 25px;
    }

  }

  .bigBox {
    display: flex;
    justify-content: end;
    align-items: center;
    width: 100%;
    height: 30px;
    margin: 30px auto;
    padding: 0px 0px 0px 20px;
  }
}

.banxin {
  width: 1600px;
  margin: 0 auto;
}

// 头部轮播

.topCarousel {
  margin-top: 50px;
  width: 100%;

  /deep/ .el-carousel__item--card.is-active {
    width: 850px;
    // transform: translateX(231.4px) !important;
  }


  /deep/ .el-carousel__button {
    display: block;
    width: 8px;
    height: 8px;
    background: #D9D9D9;
    border-radius: 50%;
    opacity: 0.7;
    border: 0 !important;
    border-radius: 50%;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    transition: 0.3s;
  }

  /deep/ .el-carousel__indicator.is-active button {
    width: 24px;
    height: 8px;
    background: #DC3B3B;
    opacity: 1;
    border-radius: 8px;
  }

  /deep/ .el-carouse {}

  /deep/ .el-carousel__container {
    height: 280px;
  }
}


.activeFoot {
  width: 100%;
  // height: 200px;
  margin: 30px auto 0;


  .el-image {
    width: 100%;
  }
}

.act-content {
  min-height: 780px;
  width: 100%;
  margin: 0 auto 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

// 摄影师大赛布局
.art-item {
  margin-top: 20px;
  width: 785px;
  height: 330px;

  .item-img {
    width: 100%;
    height: 240px;
    overflow: hidden;

    img {
      width: 100%;
      // height: 100%;
      object-fit: cover;
    }
  }

  .item-foot {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .text {
      h5 {
        font-size: 20px;
        font-weight: normal;
        letter-spacing: 0px;
        color: #232323;
        margin-top: 10px;
      }

      p {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        letter-spacing: 0px;
        color: #979797;
        margin-top: 10px;
      }
    }

    .el-button {
      background-color: #db3a3b;
      color: #fff;
    }
  }
}


/deep/ .el-carousel__button {
  display: block;
  width: 8px;
  height: 8px;
  background: #D9D9D9;
  border-radius: 50%;
  opacity: 0.7;
  border: 0 !important;
  border-radius: 50%;
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: 0.3s;
}

/deep/ .el-carousel__indicator.is-active button {
  width: 24px;
  height: 8px;
  background: #DC3B3B;
  opacity: 1;
  border-radius: 8px;
}

/deep/ .el-carouse {
  margin-top: 50px;
}

/deep/ .el-carousel__container {
  height: 244px;
}

.el-pagination {
  width: 100%;
  background-color: transparent;
  position: static;
  display: flex !important;
  justify-content: center !important;
}


#lbtImg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* 以下代码实现背景动画效果 */
  animation: loading 1.4s ease infinite;
  -webkit-animation: loading 1.4s ease infinite;
  background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #f0f0f0), color-stop(37%, #e3e3e3), color-stop(63%, #f0f0f0));
  background-image: -o-linear-gradient(left, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
  background-image: linear-gradient(90deg, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
  background-size: 400% 100%;
}

@-webkit-keyframes loading {
  0% {
    background-position: 100% 50%
  }

  to {
    background-position: 0 50%
  }
}

@keyframes loading {
  0% {
    background-position: 100% 50%
  }

  to {
    background-position: 0 50%
  }
}


.selx {
  /* 以下代码实现背景动画效果 */
  animation: loading 1.4s ease infinite;
  -webkit-animation: loading 1.4s ease infinite;
  background-image: -webkit-gradient(linear, left top, right top, color-stop(25%, #f0f0f0), color-stop(37%, #e3e3e3), color-stop(63%, #f0f0f0));
  background-image: -o-linear-gradient(left, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
  background-image: linear-gradient(90deg, #f0f0f0 25%, #e3e3e3 37%, #f0f0f0 63%);
  background-size: 400% 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/activities.vue